export default __webpack_public_path__ + "static/jhanvi-c54af6234c1e65552a39d9984055ce96.jpg";